import 'css/src/components/common/video-preview/MuteToggle';

import React, { useCallback } from 'react';

import Tooltip from 'js/src/components/common/ui/Tooltip';

type MuteToggleProps = {
    muted: boolean;
    toggleMute: (muted: boolean) => void;
    tooltipTitle?: string;
    tooltipShortcut?: string;
};

const MuteToggle = React.memo(function MuteToggle({
    muted,
    toggleMute,
    tooltipTitle,
    tooltipShortcut,
}: MuteToggleProps) {
    const onClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            e.stopPropagation();

            toggleMute(!muted);
        },
        [muted, toggleMute],
    );

    const muteIconClass = muted ? 'volume_off' : 'volume_up';
    const anchor = (
        <a href="#" onClick={onClick}>
            <i className="material-symbols-outlined">{muteIconClass}</i>
        </a>
    );
    return (
        <div className="mute-toggle">
            {tooltipTitle ? (
                <Tooltip title={tooltipTitle} shortcut={tooltipShortcut}>
                    {anchor}
                </Tooltip>
            ) : (
                anchor
            )}
        </div>
    );
});

export default MuteToggle;
